<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row justify-content-lg-end">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div class="text-sm copyright text-muted text-lg-end">
            © {{ new Date().getFullYear() }}, made with
            <i class="fa fa-heart" aria-hidden="true"></i> by
            <a href="https://runsolutions.is" class="font-weight-bold" target="_blank" rel="noopener noreferrer">Rún Solutions</a>
            | Version: {{ version }}
          </div>
        </div>
        
      </div>
    </div>
</footer>
</template>

<script>
import packageJson from '../../package.json';

export default {
  name: "AppFooter",
  data() {
    return {
      version: packageJson.version
    };
  },
};
</script>
